import React from "react";
import { FACTIONS } from "../data/factions.js";

export function avatarHash(name) {
  return [...name].reduce((sum, ch, i) => sum + ch.charCodeAt(0) * (i + 3), 0);
}

export default function GeneralAvatar({ name, gender = "m", faction = "neutral", size = 38 }) {
  const hash = avatarHash(name);
  const F = FACTIONS[faction] || FACTIONS.neutral;
  const hairColors = ["#17130f", "#34251b", "#5b3825", "#8a6a46"];
  const skinColors = ["#f0c6a4", "#d99f7b", "#e7b58f", "#c98768"];
  const hair = hairColors[hash % hairColors.length];
  const skin = skinColors[Math.floor(hash / 7) % skinColors.length];
  const female = gender === "f";
  const uid = `avatar-${hash}-${name.length}-${female ? "f" : "m"}`;
  return (
    <svg width={size} height={Math.round(size * 1.25)} viewBox="0 0 48 60" role="img" aria-label={`${name}头像`} style={{ flex: "0 0 auto", borderRadius: 4, border: `1px solid ${F.color}99`, background: F.dark, boxShadow: "0 2px 5px rgba(0,0,0,0.35)" }}>
      <defs><linearGradient id={uid} x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor={F.light} stopOpacity="0.7" /><stop offset="1" stopColor={F.dark} /></linearGradient></defs>
      <rect width="48" height="60" rx="4" fill={`url(#${uid})`} />
      <path d={female ? "M7 58 Q8 37 17 34 Q24 31 31 34 Q40 37 41 58Z" : "M5 58 Q7 36 16 34 Q24 31 32 34 Q41 36 43 58Z"} fill={F.color} />
      <path d="M15 34 Q24 29 33 34 L36 48 Q24 55 12 48Z" fill={skin} />
      {female ? <path d="M11 31 Q9 13 24 9 Q39 13 37 33 L33 29 L31 18 Q24 22 16 18 L15 31Z" fill={hair} /> : <path d="M12 29 Q9 12 24 8 Q39 12 36 29 L31 20 Q24 23 16 20Z" fill={hair} />}
      <path d="M18 31 Q24 35 30 31" fill="none" stroke="#7b4939" strokeWidth="1" />
      <circle cx="19" cy="27" r="1.2" fill="#2a2118" /><circle cx="29" cy="27" r="1.2" fill="#2a2118" />
      {female ? <path d="M8 14 Q24 2 40 14 L36 18 Q24 11 12 18Z" fill={F.color} opacity="0.9" /> : <path d="M10 15 Q24 2 38 15 L34 18 Q24 11 14 18Z" fill={F.color} opacity="0.9" />}
      <text x="24" y="56" textAnchor="middle" fontSize="7" fill="#fff8e5" fontFamily="serif">{name.slice(-1)}</text>
    </svg>
  );
}
